import axiosInstance from '../functions/axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const getFhirJson = async (foi = null, fli = null, apiToken = null, pageViewing = false) => {
    if (!apiToken) {
        //console.log("CALLING SERVER with getfhirresource");
        return await axiosInstance({
            method: 'POST',
            url: fevir_node_server_address,
            timeout: 120000,
            data: {
                "functionid": "getfhirresource",
                "resourceid": foi,
                "fli": fli
            },
        }).then((resp) => {
            if (resp?.data) {
                //resp.data is an object with {
                //  'success': true, 'found': true, 'foi': resourceId,
                //   'fhirjson': data.toolstate, 'title': title, 'status': status,
                //   'loggedin': loggedin, 'readpermission': true, 'editpermission': editpermission,
                //  'adminpermission': adminpermission, "resourcetype": resourceTypeFound,
                //   "commentsdict": {}, "trackingon": boolean    }
                if (resp.data.fhirjson) {
                    return resp.data.fhirjson;
                } else if (resp.data.found) {
                    return null;
                }
            }
            console.log("NO RESPONSE from getfhirresource call");
        }).catch((error) => { console.log(error); });
    }
    //console.log("CALLING SERVER with getresourcejson")
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            "functionid": "getresourcejson",
            "resourceid": foi,
            "apiToken": apiToken,
            "fli": fli,
            "pageviewing": pageViewing //For WebSocket purposes, kind of hacky, from what I can tell this function isn't used, I'm not sure?
        },
    }).then((resp) => {
        if (resp?.data) {
            //resp.data is Resource JSON as an object
            return resp.data;
        }
        console.log("NO RESPONSE from getresourcejson call");
    }).catch((error) => { console.log(error); });
};

const getFhirJsonWithTrackingOnValue = async (foi = null, fli = null, apiToken = null, connectionId = null, pageViewing = false) => {
    //console.log("CALLING SERVER with getfhirresource");
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            "functionid": "getfhirresource",
            "resourceid": foi,
            "apiToken": apiToken,
            "fli": fli,
            "pageviewing": pageViewing, //For WebSocket purposes when retrieving resource collection, kind of hacky
            "connectionId": connectionId
        },
    }).then((resp) => {
        if (resp?.data) {
            //resp.data is an object with {
            //  'success': true, 'found': true, 'foi': resourceId,
            //   'fhirjson': data.toolstate, 'title': title, 'status': status,
            //   'loggedin': loggedin, 'readpermission': true, 'editpermission': editpermission,
            //  'adminpermission': adminpermission, "resourcetype": resourceTypeFound,
            //   "commentsdict": {}, "trackingon": boolean    }
            let fhirJson;
            if (resp.data.fhirjson) {
                fhirJson = resp.data.fhirjson;
            } else if (resp.data.found) {
                fhirJson = null;
            }
            return [fhirJson, resp.data.trackingon];
        }
        console.log("NO RESPONSE from getfhirresource call");
    }).catch((error) => { console.log(error); });
};

export default getFhirJson;
export { getFhirJsonWithTrackingOnValue };